export type UserState = ReturnType<typeof buildUserState>;

export function buildUserState() {
	return {
		companyKennitala: '',
		email: '',
		entityType: '',
		exp: 0,
		flowType: '',
		givenName: '',
		isManualSignCompany: false,
		kennitala: '',
		phone: '',
		token: ''
	};
}
